import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import Header from "../../Header";
import "../css/home.css";
import { Container, Row, Col, Card, Nav, Tab } from "react-bootstrap";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";
import Community from "../../community";
import Footer from "../Footer/NewFooter";
const Home2 = () => {
  const preScroll = useRef(null);
  const elemRef = useRef(null);
  const [scale, setScale] = useState(1.05);
  const [stepsprocessDark, setStepsprocessDark] = useState(100);
  const [keyFeature, setkeyFeature] = useState(false);
  const [connectWalletNow, setConnectWalletNow] = useState(false);

  const [Animated, setAnimated] = useState("");

  const [herobanner, setherobannerId] = useState("herobanner");
  const [animationClass, setAnimationClass] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpanded1, setIsExpanded1] = useState(false);
  const [isExpanded2, setIsExpanded2] = useState(false);
  const [isExpanded3, setIsExpanded3] = useState(false);
  const [isExpanded4, setIsExpanded4] = useState(false);
  const [isExpanded5, setIsExpanded5] = useState(false);
  const [isExpanded6, setIsExpanded6] = useState(false);

  useEffect(() => {
    // Add your animation class when the component mounts
    // setAnimationClass('animate');

    // Remove the animation class after a certain duration (adjust as needed)
    const timeout = setTimeout(() => {
      setAnimationClass("");
    }, 3000); // Example: Remove the class after 3000 milliseconds (3 seconds)

    // Cleanup the timeout to avoid memory leaks
    return () => clearTimeout(timeout);
  }, []); // Empty
  const ref = useRef();
  useLayoutEffect(() => {
    const botPos = (element) => {
      console.log(ref);
      return element.getBoundingClientRect().bottom;
    };
    const onScroll = (e) => {
      const divBotPos = botPos(elemRef.current);
      const scrollPos = preScroll.current > window.scrollY;
      console.log({ scrollPos, divBotPos });
      if (divBotPos < 380) {
        setAnimated("animated");
      }

      if (divBotPos < -700 && stepsprocessDark == 100) {
        setStepsprocessDark(0);
      }

      if (divBotPos < -200 && !keyFeature) {
        setkeyFeature(true);
      }

      preScroll.current = window.scrollY;
      if (scrollPos && divBotPos > window.innerHeight) {
        setScale(1);
        return;
      }
      if (divBotPos < window.innerHeight) {
        setScale(2.5);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const listenScrollEvent = (event) => {
    if (window.scrollY < 73) {
      return setherobannerId("herobanner");
    } else if (window.scrollY > 70) {
      return setherobannerId("");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);

    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);
  return (
    <>
      {/* <GeneralNavbar /> */}
      <Header
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setConnectWalletNow}
      />
      <div className="overflow-hidden">
        <section className="hero-banner  pt-5" id={herobanner}>
          <div className="shapeEllipse">
            <img src="assets/images/shape1.svg" className="shape shape1" />
            <img src="assets/images/shape2.svg" className="shape shape2" />
          </div>
          <Container>
            <Card className="border-0 overflow-hidden">
              <Card.Body className="p-0">
                <Row className="" style={{ minHeight: "500px" }}>
                  <Col lg={6}>
                    <div className="p-4">
                      <div className="banner-content me-xl-5">
                        <h1 className="secure-swaps lh-1 fw-bold text-uppercase mb-2">
                          INFI MultiChain CDEX Exchange
                        </h1>
                        <h3 className="mb-3 fs-4 ">
                          Powering the Next Era of Crypto with SbSe Instant Swaps, OTC Deals & Web4 Payments
                          The Most Advanced MultiChain Exchange
                          & Launchpad for Builders, Traders &
                          Web4 Innovators
                        </h3>
                        
                        <p className="mb-1 fs-4">
                          Welcome to INFI MultiChain CDEX Exchange, your gateway to the future of crypto trading, token launches, and blockchain-based finance.
                          Launch your crypto project with zero-cost fees across 14 blockchains, profit from cross-chain instant swaps, and access exclusive SbSe OTC deals — including 53+ top crypto assets at up to 10% cheaper than the market price.
                          All of this is powered by the SbSe Protocol, running through our Hybrid INFI eWallet and blockchain-based INFI eBank, with a sleek, Web4-ready interface designed for both beginners and pros
                        </p>
                        <p></p>
                        {/* Show the second paragraph only when isExpanded is true */}
                        {/* {isExpanded && (
                          <p className='mb-0'>
                            The &copy;SbSe Protocol is a self-sustaining, intelligent ecosystem that is critical
                            to cryptocurrency, digital payments, and tokenization. Launched on the INFI MultiChain
                            CDEX Exchange, it works across six blockchains and promotes fair trading by minimizing
                            volatility and reducing the risk of fraud while managing liquidity. It also provides
                            users with a distinctive reward model for each transaction, a unique passive income
                            opportunity for INFI holders, and a 48-hour compensation plan for those affected by fraud.
                          </p>
                        )}
                        <button className="bg-transparent border-0  fw-normal" style={{ color: "#505050" }} onClick={() => setIsExpanded(!isExpanded)}>
                          {isExpanded ? "Read Less" : "..Read More"}
                        </button> */}
                      </div>
                      <div className="banner-content-card me-xl-5">
                        <div className="p-3">
                          <p>
                            The SbSe Protocol is a self-sustaining,
                            intelligent ecosystem that is critical to
                            cryptocurrency, digital payments, and tokenization.
                            Launched on the INFI MultiChain CDEX Exchange, it
                            works across six blockchains and promotes fair&nbsp;
                            {isExpanded && (
                              <span>
                                trading by minimizing volatility and reducing
                                the risk of fraud while managing liquidity.It
                                also provides users with a distinctive reward
                                model for each transaction, a unique passive
                                income opportunity for INFI holders, and a
                                48-hour compensation plan for those affected by
                                fraud.&nbsp;
                              </span>
                            )}
                            <button
                              className="bg-transparent border-0"
                              onClick={() => setIsExpanded(!isExpanded)}
                            >
                              {isExpanded ? "Read Less" : "..Read More"}
                            </button>
                          </p>
                          {/* 
                          <div className='d-sm-flex gap-5 mb-sm-3'>
                            <div className=''>
                              <div >
                                <h4 className='mb-0 '>$1 Billion</h4>
                                <p className='mb-0 fs-5'>Total Value Swapped</p>
                              </div>
                            </div>
                            <div className=''>
                              <div>
                                <h4 className='mb-0'>50,000+</h4>
                                <p className='mb-0 fs-5'>Successful Trades</p>
                              </div>
                            </div>
                          </div>
                          <div className='d-sm-flex gap-5'>
                            <div className=''>
                              <div>
                                <h4 className='mb-0'>98%</h4>
                                <p className='mb-0 fs-5'>User Satisfaction Rate</p>
                              </div>
                            </div>
                            <div className=''>
                              <div className=''>
                                <h4 className='mb-0'>100+</h4>
                                <p className='mb-0 fs-5'>Supported Cryptocurrencies</p>
                              </div>
                            </div>
                          </div>*/}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col
                    lg={6}
                    className={`position-relative  animated-element${animationClass}`}
                  >
                    <div style={{ marginTop: "50" }} className="">
                      <img
                        src="assets/images/coinanimation3.png"
                        className="coingif"
                        alt=""
                      />
                    </div>
                  </Col>
                  {/* } */}
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </section>
        <section className="secure position-relative overflow-hidden">
          <Container>
            <div className="screenShadow">
              <img src="assets/images/shadowbg.png" />
            </div>
            <div className="secure-content p-3">
              <div className="leftshape position-absolute start-0 top-0">
                <img src="assets/images/shape/leftshape.svg" />
              </div>
              <div className="rightshape position-absolute end-0 top-0">
                <img src="assets/images/shape/rightshape.svg" />
              </div>
              <Row className="">
                <Col lg={8} md={8} xs={12} className="">
                  <div className="big-content" ref={elemRef}>
                    <div className="securebox mb-md-4 mb-3">
                      {/* // <div><span className='pb-2 me-3'>Establishing a</span></div> */}
                      <h1
                        className="mb-0"
                        onClick={() => setAnimated(!Animated ? "animated" : "")}
                      >
                        {" "}
                        SECURITY
                      </h1>
                    </div>
                    <p>
                      remains our top priority. With our unique ©SbSe Protocol
                      and the advanced cybersecurity measures provided by our
                      business partner Cyvers, we are well equipped to protect
                      our systems.
                    </p>
                  </div>
                </Col>
                <Col lg={4} md={4} xs={12} className="text-center">
                  <div className="shield position-relative">
                    <img src="assets/images/shield.png" />
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        <section className="keyfeatures pt-5 bg-transparent z-2 ">
          <Container className="">
            <Row>
              <Col lg={12} md={12} xs={12} className="text-center">
                <div className="heading">
                  <h1 className="text-primary fw-bold">KEY FEATURES</h1>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} xs={12} className="pt-5">
                <div className="keyfeatures-content position-relative">
                  <Row className="align-items-center">
                    <div className="tabStyle">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="first"
                      >
                        <Row className="align-items-center">
                          <Col sm={6}>
                            <Nav variant="pills" className="flex-column">
                              <Nav.Item className="mb-4">
                                <Nav.Link eventKey="first">
                                  <div>
                                    <h4>
                                      Zero-Cost Launchpad for Future Crypto Projects
                                      <span className="ms-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="32"
                                          height="32"
                                          viewBox="0 0 32 48"
                                          fill="none"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M23.4402 8.56018C20.9197 6.03971 20.2727 0 20.2727 0C20.2727 0 19.6256 6.03971 17.1051 8.56018C14.5846 11.0807 8.54492 11.7277 8.54492 11.7277C8.54492 11.7277 14.5846 12.3748 17.1051 14.8953C19.6256 17.4158 20.2727 23.4555 20.2727 23.4555C20.2727 23.4555 20.9197 17.4158 23.4402 14.8953C25.9607 12.3748 32.0004 11.7277 32.0004 11.7277C32.0004 11.7277 25.9607 11.0807 23.4402 8.56018ZM12.4127 34.9801C10.3123 32.8797 9.77311 27.8466 9.77311 27.8466C9.77311 27.8466 9.23388 32.8797 7.13348 34.9801C5.03309 37.0805 0 37.6197 0 37.6197C0 37.6197 5.03309 38.159 7.13348 40.2594C9.23388 42.3597 9.77311 47.3928 9.77311 47.3928C9.77311 47.3928 10.3123 42.3597 12.4127 40.2594C14.5131 38.159 19.5462 37.6197 19.5462 37.6197C19.5462 37.6197 14.5131 37.0805 12.4127 34.9801Z"
                                            fill="url(#paint0_linear_431_29)"
                                          />
                                          <defs>
                                            <linearGradient
                                              id="paint0_linear_431_29"
                                              x1="16.0002"
                                              y1="0"
                                              x2="16.0002"
                                              y2="47.3928"
                                              gradientUnits="userSpaceOnUse"
                                            >
                                              <stop stop-color="#55C57D" />
                                              <stop
                                                offset="1"
                                                stop-color="#4CBAD5"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      </span>
                                    </h4>
                                    <span className="mb-0">
                                      Know Your Customer (KYC) procedures and
                                      audits are critical, but they alone cannot
                                      completely eliminate fraud. To enhance our
                                      Launchpad and trading system,{" "}
                                    </span>
                                    {/* Show the second paragraph only when isExpanded is true */}
                                    {/* {isExpanded1 && (
                                      <span className="mb-0">
                                        we have implemented a Special Liquidity
                                        Management and SbSe Reserve feature,
                                        This includes a 48- hour compensation
                                        plan to provide investors with peace of
                                        mind.
                                      </span>
                                    )} */}
                                    {/* <span className="me-2">
                                      <button
                                        className="bg-transparent border-0 fw-semibold text-primary"
                                        onClick={() =>
                                          setIsExpanded1(!isExpanded1)
                                        }
                                      >
                                        {isExpanded1
                                          ? "...Read Less"
                                          : "..Read More"}
                                      </button>
                                    </span> */}
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="mb-4">
                                <Nav.Link eventKey="second">
                                  <div>
                                    <h4>
                                      High-Speed Cross-Chain Instant Swaps
                                      <span className="ms-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="32"
                                          height="32"
                                          viewBox="0 0 32 48"
                                          fill="none"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M23.4402 8.56018C20.9197 6.03971 20.2727 0 20.2727 0C20.2727 0 19.6256 6.03971 17.1051 8.56018C14.5846 11.0807 8.54492 11.7277 8.54492 11.7277C8.54492 11.7277 14.5846 12.3748 17.1051 14.8953C19.6256 17.4158 20.2727 23.4555 20.2727 23.4555C20.2727 23.4555 20.9197 17.4158 23.4402 14.8953C25.9607 12.3748 32.0004 11.7277 32.0004 11.7277C32.0004 11.7277 25.9607 11.0807 23.4402 8.56018ZM12.4127 34.9801C10.3123 32.8797 9.77311 27.8466 9.77311 27.8466C9.77311 27.8466 9.23388 32.8797 7.13348 34.9801C5.03309 37.0805 0 37.6197 0 37.6197C0 37.6197 5.03309 38.159 7.13348 40.2594C9.23388 42.3597 9.77311 47.3928 9.77311 47.3928C9.77311 47.3928 10.3123 42.3597 12.4127 40.2594C14.5131 38.159 19.5462 37.6197 19.5462 37.6197C19.5462 37.6197 14.5131 37.0805 12.4127 34.9801Z"
                                            fill="url(#paint0_linear_431_29)"
                                          />
                                          <defs>
                                            <linearGradient
                                              id="paint0_linear_431_29"
                                              x1="16.0002"
                                              y1="0"
                                              x2="16.0002"
                                              y2="47.3928"
                                              gradientUnits="userSpaceOnUse"
                                            >
                                              <stop stop-color="#55C57D" />
                                              <stop
                                                offset="1"
                                                stop-color="#4CBAD5"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      </span>
                                    </h4>
                                    <span className="mb-0">
                                      Experience lightning-fast cross-chain swaps with INFI's advanced
                                      technology. Swap assets between different blockchains instantly,
                                      reducing latency and enhancing trading efficiency.
                                    </span>

                                    {/* Show the second paragraph only when isExpanded2 is true */}
                                    {/* {isExpanded2 && (
                                      <span className="mb-0">
                                        specialized listing options, a unique
                                        cash-back model, and dedicated liquidity
                                        management across six blockchains:
                                        Binance Smart Chain, Avalanche,
                                        Arbitrum, Polygon, Ethereum and Base.
                                      </span>
                                    )} */}
                                    {/* <span className="me-2">
                                      <button
                                        className="bg-transparent border-0 fw-semibold text-primary"
                                        onClick={() =>
                                          setIsExpanded2(!isExpanded2)
                                        }
                                      >
                                        {isExpanded2
                                          ? "...Read Less"
                                          : "..Read More"}
                                      </button>
                                    </span> */}
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="mb-4">
                                <Nav.Link eventKey="third">
                                  <div>
                                    <h4>
                                      SbSe OrderBook OTC Deals with Minimal Fees
                                      <span className="ms-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="32"
                                          height="32"
                                          viewBox="0 0 32 48"
                                          fill="none"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M23.4402 8.56018C20.9197 6.03971 20.2727 0 20.2727 0C20.2727 0 19.6256 6.03971 17.1051 8.56018C14.5846 11.0807 8.54492 11.7277 8.54492 11.7277C8.54492 11.7277 14.5846 12.3748 17.1051 14.8953C19.6256 17.4158 20.2727 23.4555 20.2727 23.4555C20.2727 23.4555 20.9197 17.4158 23.4402 14.8953C25.9607 12.3748 32.0004 11.7277 32.0004 11.7277C32.0004 11.7277 25.9607 11.0807 23.4402 8.56018ZM12.4127 34.9801C10.3123 32.8797 9.77311 27.8466 9.77311 27.8466C9.77311 27.8466 9.23388 32.8797 7.13348 34.9801C5.03309 37.0805 0 37.6197 0 37.6197C0 37.6197 5.03309 38.159 7.13348 40.2594C9.23388 42.3597 9.77311 47.3928 9.77311 47.3928C9.77311 47.3928 10.3123 42.3597 12.4127 40.2594C14.5131 38.159 19.5462 37.6197 19.5462 37.6197C19.5462 37.6197 14.5131 37.0805 12.4127 34.9801Z"
                                            fill="url(#paint0_linear_431_29)"
                                          />
                                          <defs>
                                            <linearGradient
                                              id="paint0_linear_431_29"
                                              x1="16.0002"
                                              y1="0"
                                              x2="16.0002"
                                              y2="47.3928"
                                              gradientUnits="userSpaceOnUse"
                                            >
                                              <stop stop-color="#55C57D" />
                                              <stop
                                                offset="1"
                                                stop-color="#4CBAD5"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      </span>
                                    </h4>
                                    <span className="mb-0">
                                      Engage in over-the-counter (OTC) trades with INFI's SbSe
                                      OrderBook, offering sub-second settlement times and significantly
                                      lower fees compared to traditional platforms. Buy over 53 top
                                      cryptocurrencies at up to 10% cheaper than market price, thanks to
                                      our ©SbSe Protocol.
                                    </span>

                                    {/* {isExpanded3 && (
                                      <span className="mb-0">
                                        Every month, 100% of the earnings from
                                        SbSe PFP and SbSe BTC will be
                                        distributed to our INFI holders in USDT,
                                        Bitcoin or even INFI. In addition, users
                                        of our trading platform will receive
                                        cashback rewards after each transaction.
                                      </span>
                                    )} */}
                                    {/* <span className="me-2">
                                      <button
                                        className="bg-transparent border-0 fw-semibold text-primary"
                                        onClick={() =>
                                          setIsExpanded3(!isExpanded3)
                                        }
                                      >
                                        {isExpanded3
                                          ? "...Read Less"
                                          : "..Read More"}
                                      </button>
                                    </span> */}
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="mb-4">
                                <Nav.Link eventKey="fourth">
                                  <div>
                                    <h4>
                                      Hold INFI and Earn Monthly Passive Income
                                      <span className="ms-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="32"
                                          height="32"
                                          viewBox="0 0 32 48"
                                          fill="none"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M23.4402 8.56018C20.9197 6.03971 20.2727 0 20.2727 0C20.2727 0 19.6256 6.03971 17.1051 8.56018C14.5846 11.0807 8.54492 11.7277 8.54492 11.7277C8.54492 11.7277 14.5846 12.3748 17.1051 14.8953C19.6256 17.4158 20.2727 23.4555 20.2727 23.4555C20.2727 23.4555 20.9197 17.4158 23.4402 14.8953C25.9607 12.3748 32.0004 11.7277 32.0004 11.7277C32.0004 11.7277 25.9607 11.0807 23.4402 8.56018ZM12.4127 34.9801C10.3123 32.8797 9.77311 27.8466 9.77311 27.8466C9.77311 27.8466 9.23388 32.8797 7.13348 34.9801C5.03309 37.0805 0 37.6197 0 37.6197C0 37.6197 5.03309 38.159 7.13348 40.2594C9.23388 42.3597 9.77311 47.3928 9.77311 47.3928C9.77311 47.3928 10.3123 42.3597 12.4127 40.2594C14.5131 38.159 19.5462 37.6197 19.5462 37.6197C19.5462 37.6197 14.5131 37.0805 12.4127 34.9801Z"
                                            fill="url(#paint0_linear_431_29)"
                                          />
                                          <defs>
                                            <linearGradient
                                              id="paint0_linear_431_29"
                                              x1="16.0002"
                                              y1="0"
                                              x2="16.0002"
                                              y2="47.3928"
                                              gradientUnits="userSpaceOnUse"
                                            >
                                              <stop stop-color="#55C57D" />
                                              <stop
                                                offset="1"
                                                stop-color="#4CBAD5"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      </span>
                                    </h4>
                                    <span className="mb-0">
                                      By holding INFI tokens, users can earn monthly passive income. The
                                      platform distributes 100% of its profits in USDT Bitcoin or INFI,
                                      providing a steady income stream for token holders.
                                    </span>

                                    {/* {isExpanded4 && (
                                      <span className="mb-0">
                                        Every month, 100% of the earnings from
                                        SbSe PFP and SbSe BTC will be
                                        distributed to our INFI holders in USDT,
                                        Bitcoin or even INFI. In addition, users
                                        of our trading platform will receive
                                        cashback rewards after each transaction.
                                      </span>
                                    )} */}
                                    {/* <span className="me-2">
                                      <button
                                        className="bg-transparent border-0 fw-semibold text-primary"
                                        onClick={() =>
                                          setIsExpanded4(!isExpanded4)
                                        }
                                      >
                                        {isExpanded4
                                          ? "...Read Less"
                                          : "..Read More"}
                                      </button>
                                    </span> */}
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="mb-4">
                                <Nav.Link eventKey="five">
                                  <div>
                                    <h4>
                                      Powered by the ©SbSe Protocol
                                      <span className="ms-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="32"
                                          height="32"
                                          viewBox="0 0 32 48"
                                          fill="none"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M23.4402 8.56018C20.9197 6.03971 20.2727 0 20.2727 0C20.2727 0 19.6256 6.03971 17.1051 8.56018C14.5846 11.0807 8.54492 11.7277 8.54492 11.7277C8.54492 11.7277 14.5846 12.3748 17.1051 14.8953C19.6256 17.4158 20.2727 23.4555 20.2727 23.4555C20.2727 23.4555 20.9197 17.4158 23.4402 14.8953C25.9607 12.3748 32.0004 11.7277 32.0004 11.7277C32.0004 11.7277 25.9607 11.0807 23.4402 8.56018ZM12.4127 34.9801C10.3123 32.8797 9.77311 27.8466 9.77311 27.8466C9.77311 27.8466 9.23388 32.8797 7.13348 34.9801C5.03309 37.0805 0 37.6197 0 37.6197C0 37.6197 5.03309 38.159 7.13348 40.2594C9.23388 42.3597 9.77311 47.3928 9.77311 47.3928C9.77311 47.3928 10.3123 42.3597 12.4127 40.2594C14.5131 38.159 19.5462 37.6197 19.5462 37.6197C19.5462 37.6197 14.5131 37.0805 12.4127 34.9801Z"
                                            fill="url(#paint0_linear_431_29)"
                                          />
                                          <defs>
                                            <linearGradient
                                              id="paint0_linear_431_29"
                                              x1="16.0002"
                                              y1="0"
                                              x2="16.0002"
                                              y2="47.3928"
                                              gradientUnits="userSpaceOnUse"
                                            >
                                              <stop stop-color="#55C57D" />
                                              <stop
                                                offset="1"
                                                stop-color="#4CBAD5"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      </span>
                                    </h4>
                                    <span className="mb-0">
                                      INFI operates on the ©SbSe Protocol, ensuring secure and efficient
                                      transactions across the platform. This protocol bridges real-world
                                      enterprises and blockchain networks, setting a new standard in
                                      digital payment infrastructure within the Web3 and Web4 framework.
                                    </span>

                                    {/* {isExpanded5 && (
                                      <span className="mb-0">
                                        Every month, 100% of the earnings from
                                        SbSe PFP and SbSe BTC will be
                                        distributed to our INFI holders in USDT,
                                        Bitcoin or even INFI. In addition, users
                                        of our trading platform will receive
                                        cashback rewards after each transaction.
                                      </span>
                                    )} */}
                                    {/* <span className="me-2">
                                      <button
                                        className="bg-transparent border-0 fw-semibold text-primary"
                                        onClick={() =>
                                          setIsExpanded5(!isExpanded5)
                                        }
                                      >
                                        {isExpanded5
                                          ? "...Read Less"
                                          : "..Read More"}
                                      </button>
                                    </span> */}
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="mb-4">
                                <Nav.Link eventKey="six">
                                  <div>
                                    <h4>
                                      INFI Hybrid eWallet and eBank
                                      <span className="ms-1">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="32"
                                          height="32"
                                          viewBox="0 0 32 48"
                                          fill="none"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M23.4402 8.56018C20.9197 6.03971 20.2727 0 20.2727 0C20.2727 0 19.6256 6.03971 17.1051 8.56018C14.5846 11.0807 8.54492 11.7277 8.54492 11.7277C8.54492 11.7277 14.5846 12.3748 17.1051 14.8953C19.6256 17.4158 20.2727 23.4555 20.2727 23.4555C20.2727 23.4555 20.9197 17.4158 23.4402 14.8953C25.9607 12.3748 32.0004 11.7277 32.0004 11.7277C32.0004 11.7277 25.9607 11.0807 23.4402 8.56018ZM12.4127 34.9801C10.3123 32.8797 9.77311 27.8466 9.77311 27.8466C9.77311 27.8466 9.23388 32.8797 7.13348 34.9801C5.03309 37.0805 0 37.6197 0 37.6197C0 37.6197 5.03309 38.159 7.13348 40.2594C9.23388 42.3597 9.77311 47.3928 9.77311 47.3928C9.77311 47.3928 10.3123 42.3597 12.4127 40.2594C14.5131 38.159 19.5462 37.6197 19.5462 37.6197C19.5462 37.6197 14.5131 37.0805 12.4127 34.9801Z"
                                            fill="url(#paint0_linear_431_29)"
                                          />
                                          <defs>
                                            <linearGradient
                                              id="paint0_linear_431_29"
                                              x1="16.0002"
                                              y1="0"
                                              x2="16.0002"
                                              y2="47.3928"
                                              gradientUnits="userSpaceOnUse"
                                            >
                                              <stop stop-color="#55C57D" />
                                              <stop
                                                offset="1"
                                                stop-color="#4CBAD5"
                                              />
                                            </linearGradient>
                                          </defs>
                                        </svg>
                                      </span>
                                    </h4>
                                    <span className="mb-0">
                                      Manage your digital assets effortlessly with the INFI Hybrid eWallet
                                      and blockchain-based INFI eBank. These tools provide a userfriendly interface for seamless transactions and financial
                                      management.
                                    </span>

                                    {/* {isExpanded5 && (
                                      <span className="mb-0">
                                        Every month, 100% of the earnings from
                                        SbSe PFP and SbSe BTC will be
                                        distributed to our INFI holders in USDT,
                                        Bitcoin or even INFI. In addition, users
                                        of our trading platform will receive
                                        cashback rewards after each transaction.
                                      </span>
                                    )} */}
                                    {/* <span className="me-2">
                                      <button
                                        className="bg-transparent border-0 fw-semibold text-primary"
                                        onClick={() =>
                                          setIsExpanded5(!isExpanded5)
                                        }
                                      >
                                        {isExpanded5
                                          ? "...Read Less"
                                          : "..Read More"}
                                      </button>
                                    </span> */}
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </Col>
                          <Col sm={6}>
                            <Tab.Content>
                              <Tab.Pane eventKey="first">
                                <div className="handblock">
                                  <div className="handanimation">
                                    <img
                                      src="assets/images/handCoin.png "
                                      className="chain"
                                    />
                                    <Fade bottom>
                                      <img
                                        src="assets/images/handImg.png"
                                        className=" handImg"
                                      />
                                    </Fade>
                                  </div>
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="second">
                                <div className="handblock p-5">
                                  <div className="handanimation p-5 ">
                                    <Fade bottom>
                                      <img
                                        src="assets/images/graphic.png"
                                        className=" w-100"
                                      />
                                    </Fade>
                                  </div>
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="third">
                                <div className="handblock p-5">
                                  <div className="handanimation text-center">
                                    <Fade bottom>
                                      <img
                                        src="assets/images/rewards.png "
                                        className=" w-100"
                                      />
                                    </Fade>
                                  </div>
                                </div>
                              </Tab.Pane>
                            </Tab.Content>
                          </Col>
                        </Row>
                      </Tab.Container>
                    </div>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section
          className="stepsfew pt-lg-5 pt-md-5 pb-3 position-relative z-1"
          id="howitwork"
        >
          <div className="leftcircle position-absolute start-0">
            <img src="assets/images/shape/leftcircle.png" />
          </div>
          <div className="rightcircle position-absolute end-0">
            <img src="assets/images/shape/rightcircle.png" />
          </div>
          <Container>
            <Row>
              <Col lg={12} className="customheadbox text-center">
                <Fade top>
                  <div className="heading">
                    <h1 className="text-primary fw-bold fs-1 text-uppercase">
                      Start your journey with a few{" "}
                      <span
                        className=""
                        style={{ textShadow: "0px 0px 4px #000" }}
                      >
                        simple steps!
                      </span>
                    </h1>
                  </div>
                </Fade>
              </Col>
            </Row>
            <Row className="mt-lg-5 mt-md-5 mt-3">
              <Col lg={12} md={12} className="mx-auto">
                <div className="stepsprocess">
                  <Row className="justify-content-center text-center">
                    <Col lg={4} className="mb-4">
                      <div className="stepcard">
                        <img src="assets/images/process/signup.png" />
                        <div className="mt-3">
                          <h2 className="text-primary">Sign Up</h2>
                          <p className="text-primary fs-5">
                            To create your accounts, please connect your wallet
                            and provide your email address along with a
                            password.
                          </p>
                        </div>
                      </div>
                    </Col>

                    <Col lg={4} className="mb-4">
                      <div className="stepcard">
                        <img src="assets/images/process/cta2.png" />
                        <div className="mt-3">
                          <h2 className="text-primary">CTA</h2>
                          <p className="text-primary fs-5">
                            Please check your email and activate your account
                            using the provided activation link. If you are
                            unable to locate the email, kindly check your spam
                            folder
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} className="mb-4">
                      <div className="stepcard">
                        <img src="assets/images/process/dashboard.png" />
                        <div className="mt-3">
                          <h2 className="text-primary">Manage Coins</h2>
                          <p className="text-primary fs-5">
                            Log in to your dashboard using your credentials to
                            explore your earnings. You can manage staking,
                            access profits, and review treasury and reserve
                            funds.
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section
          className="magician pt-lg-5 pt-md-5 pb-3 position-relative"
          style={{ marginBottom: "-100px" }}
        >
          <Container>
            <Row className="align-items-center pb-4 position-relative">
              <Col lg={6}>
                <Zoom>
                  <div className="whoareblock">
                    <div className="heading">
                      <h2 className="text-primary fw-bold fs-1">Who are we?</h2>
                    </div>
                    <p className="text-primary ">
                      The INFI MultiChain CDEX Exchange is introducing an
                      exciting new concept to the world of cryptocurrency! This
                      innovative platform is designed to enhance the
                      capabilities of decentralized exchanges (DEX), making it
                      easier for everyone to manage liquidity and explore a
                      wider range of investment opportunities. It also opens up
                      fantastic new opportunities for users to earn passive
                      income. It's a great time to get involved and see what
                      this vibrant community has to oﬀer!
                    </p>
                  </div>
                </Zoom>
              </Col>
              <Col lg={1} className="text-center"></Col>
              <Col lg={5} className="text-center">
                <div className="handblock">
                  <div className="position-relative">
                    <img
                      src="assets/images/coinrotate.png "
                      className="coinRotate"
                    />
                    <img src="assets/images/whoweare.png " className="" />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Community />
      <Footer />
    </>
  );
};

export default Home2;
